import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Field, Rule} from "../../../../_typing/query-builder";
import {QueryBuilderFormService} from "../../../../services/query-builder-form.service";
import {BaseComponent} from "../../../../shared/base.component";
import {KeyMap} from "../../../../_typing/generic-types";
import {COMMON_FORM_IMPORTS} from "../../../../shared/import-groups/Common";


@Component({
    selector: 'wire-query-operator',
    templateUrl: './wire-query-operator.component.html',
    imports: [
        COMMON_FORM_IMPORTS
    ],
    styleUrls: ['./wire-query-operator.component.scss']
})
export class WireQueryOperatorComponent extends BaseComponent {
    @Input() rule: Rule;
    @Input() field: Field
    @Output() selectedOperatorChanged: EventEmitter<string> = new EventEmitter();
    operatorMap: KeyMap<string[]>;
    operatorDesc: KeyMap<string>;

    constructor(private queryBuilderFormService: QueryBuilderFormService) {
        super();
        this.operatorMap = this.queryBuilderFormService.operatorMap;
        this.operatorDesc = this.queryBuilderFormService.operatorDesc;
    }


    setSelectedOperator(event: string): any {
        this.selectedOperatorChanged.next(event);
    }
}
